
export default function (vueComp, dataName) {
  const originData = vueComp.$options.data()[dataName]
  const nowData = vueComp[dataName]
  console.log('dataChange',vueComp,originData,nowData)

  if(!originData || !nowData ){
    return 0
  }
  let count = 0
  const keys = Object.keys(nowData)

  keys.forEach( item => {
    if(nowData[item] && item != 'pagedQueryInfo' && item != 'hospCode'){
      if(Object.prototype.toString.call(nowData[item]).indexOf('Array') !== -1){
        if(nowData[item].length > 0){
          count ++
        }
      }else{
        if(nowData[item] != originData[item]){
          console.log('eq:'+item,nowData[item] ,originData[item])
          count ++
        }
      }

    }
  })
  return count
}
